/**
 * A price that shows the SRP struck-through + the discounted price + a `−X%`
 * tag whenever `now < base` (a slot discount is live); otherwise just the price.
 * `−X%` uses `text-success` to match the Review modal's per-line discount.
 */
export function PriceTag({
  base,
  now,
  prefix = '',
}: {
  base: number;
  now: number;
  prefix?: string;
}) {
  if (!(now < base))
    return (
      <span className="font-semibold">
        {prefix}₱{now.toFixed(2)}
      </span>
    );
  const pct = Math.round((1 - now / base) * 100);
  return (
    <span className="inline-flex items-baseline gap-1.5">
      <span className="text-xs text-muted-foreground line-through">
        {prefix}₱{base.toFixed(2)}
      </span>
      <span className="font-semibold text-success">
        {prefix}₱{now.toFixed(2)}
      </span>
      {pct > 0 && <span className="text-[10px] text-success">−{pct}%</span>}
    </span>
  );
}
